module.exports = __webpack_public_path__ + "assets/img/3_291.1f62ad15.jpg";